// import styles from './Alternatives.module.css';
import { ProductData } from '../../../types/Productdata.interfacew';
import { StockItem } from '../../../types/StockItem.interface';
import { ProductStockCard } from '../../../widgets/ProductStockCard/ProductStockCart';

interface Props {
    items: StockItem[],
    productData: ProductData,
}

/**
 * Блок карточек уценённых товаров
 * @param props
 * @returns 
 */
export const StockProducts: React.FC<Props> = ({ items, productData }: Props) => {
    return (
        <div className='w-full max-w-5xl mb-8'>
            <h4 className="font-bold text-xl mb-6">Уценка</h4>
            {items.map((item) => (
                <ProductStockCard key={item.id}
                    stockItemData={{
                        ...item, 
                        defectImages: [...item.defectImages, {id:123, url: productData.img_thumbnail.replace('https://podzamenu.ru', '')}]}}//TODO Заглушка для теста карусели
                    productData={productData}
                />
            ))}
        </div>
    );
};